export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,

  title: '部分放单设置详情',
} as TCommon.RouteConfig
